<template>
    <div v-if="componentData" class="wrapper ImageCarousel">

        <flickity-carousel ref="flickityCarousel" :options="flickityOptions">
            <div v-for="(image, index) in componentData.images.data " class="image__holder">
                <img :src="image.attributes.url"  :alt="image.attributes.alternativeText"/>
            </div>
        </flickity-carousel>

    </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue'

import FlickityCarousel from '../../components/FlickityCarousel.vue'

export default defineComponent({
    components:{
        FlickityCarousel
    },
    data() {
        return {
            flickityOptions: {
                pageDots: false,

                // groupCells: true,
                // contain: true,
                cellAlign: 'center',
                wrapAround: true,
                groupCells: true,
                prevNextButtons: false,
            }
        }
    },
    props:{
        componentData: {
            type: Object,
            required: false
        },
    },
    setup(props) {
        const homeurl: string = import.meta.env.VITE_API_URL;

        return {
            homeurl
        };
    }
})

</script>
